export function generateImageSizes(width: number): string {
  return `
  (-webkit-min-device-pixel-ratio: 2) ${width * 2}px, 
  (min-resolution: 2dppx) ${width * 2}px, 
  ${width}px
`.trim();
}
